import React from 'react';
import PropTypes from 'prop-types';
import Loading from '@nats/webclient-common/lib/components/Loading/Loading';

function LoadingSection({ busy, loadingText, children }) {
  if (busy) {
    return (
      <div>
        <h1 id="loadingSection">
          {loadingText} <Loading isLoading inline />
        </h1>
      </div>
    );
  }

  return <div>{children}</div>;
}

LoadingSection.propTypes = {
  busy: PropTypes.bool.isRequired,
  loadingText: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

export default LoadingSection;
